import { render } from "./IdentityManagerGrantsShowView.vue?vue&type=template&id=0971b049"
import script from "./IdentityManagerGrantsShowView.vue?vue&type=script&lang=js"
export * from "./IdentityManagerGrantsShowView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__